const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.CARTS)

export const apiClientCarts = {
	createOrder: async (order: IOrderSendFormModel, parentOrderID?: number) => {
		const { data } = await apiCommon<IOrder>(`${groupPrefix}/diets`, {
			method: 'POST',
			body: { ...orderToJSON(order), parent_client_diet_id: parentOrderID },
		})
		return data
	},
}
